export class DBSnapshotMetadata {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "generatedOn",
            "baseName": "generatedOn",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "DBSnapshotType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DBSnapshotMetadata.attributeTypeMap;
    }
    constructor() {
    }
}
